export default __webpack_public_path__ + "static/media/baby-34.0e44907b.svg";